var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLengehRail41Fix2Left3Left4Left(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.4 33",
    style: {
      enableBackground: "new 0 0 87.4 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2,1.3h19.7v30.3H25.2l-1,1h21.7V0.3H24.2l0,0L25.2,1.3 M25.7,6.3h14.2v20.3H24.7v1h16.2V5.3H24.7l0,0v1 M46.1,1.3h19.7 v30.3H46.1l-1,1h21.7V0.3H45.1l0,0L46.1,1.3 M46.6,6.3h14.2v20.3H45.6v1h16.2V5.3H45.6l0,0v1 M20.5,5v22.8H5V5H20.5 M21.5,4h-1H5H4 v1v22.8v1h1h15.5h1v-1V5V4L21.5,4z M24.5,1.3v30.3H1V1.3H24.5 M25.5,0.3H0v32.3h25.5V0.3L25.5,0.3z M16.4,16H8.7v1h7.7V16z M13,12.6 h-1v7.7h1V12.6z M37,16h-5.5v1H37V16z M31.9,19.8v-6.6l-3.3,3.3L31.9,19.8z M57.9,16h-5.5v1h5.5V16z M52.8,19.8v-6.6l-3.3,3.3 L52.8,19.8z M66.7,1.3h19.7v30.3H66.7l-1,1h21.7V0.3H65.7l0,0L66.7,1.3 M67.2,6.3h14.2v20.3H66.2v1h16.2V5.3H66.2l0,0v1 M78.5,16H73 v1h5.5V16z M73.4,19.8v-6.6l-3.3,3.3L73.4,19.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengehRail41Fix2Left3Left4Left);
export default __webpack_public_path__ + "static/media/LENGEH_RAIL_4_1FIX_2LEFT_3LEFT_4LEFT.ae0c280441d856ac0fe336de331e9ea6.svg";
export { ForwardRef as ReactComponent };